<template lang="html">
    <div class="d-flex flex-wrap">
        <!-- MY TEAM -->
        <button
            v-if="myTeamGroups.length > 0"
            type="button"
            class="channelBtn btn bg-lightest darker bold mr-2 mb-2"
            :class="{ 'selected': value.length > 0 && value[0].channelType == 9999 }"
            @click="selectChannel('myTeam')"
        >
            My team
        </button>

        <!-- OTHER CHANNELS -->
        <button
            v-for="salesChannel in regularChannels"
            :key="salesChannel.id"
            type="button"
            class="channelBtn btn bg-lightest darker bold mr-2 mb-2"
            :class="{ 'selected': value.length > 0 && value[0].id == salesChannel.id }"
            @click="selectChannel(salesChannel)"
        >
            {{ salesChannel.name }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'RefundChannelSelector',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        reservation: {
            type: Object,
            default: () => ({}),
        },
    },
    mounted() {
        if ((!this.value || this.value.length === 0) && this.availableChannelsNoDupes.length > 0) {
            if (this.myTeamGroups.length > 0) {
                this.selectChannel('myTeam');
            } else if (this.regularChannels.length > 0) {
                this.selectChannel(this.regularChannels[0]);
            }
        }
    },
    computed: {
        availableChannels() {
            const fromPax = (this.reservation.bookingGenderPrices || [])
                .filter(bookingGenderPrice => bookingGenderPrice.quantityToBook > 0)
                .map(bookingGenderPrice => bookingGenderPrice.channel)

            const fromExtras = (this.reservation.bookingComponents || [])
                .map(bookingComponent => bookingComponent.channel)

            return [...fromPax, ...fromExtras].filter(Boolean)
        },
        availableChannelsNoDupes() {
            const byId = new Map()
            for (const channel of this.availableChannels) {
                if (!byId.has(channel.id)) {
                    byId.set(channel.id, channel)
                }
            }
            return [...byId.values()]
        },
        regularChannels() {
            // RETURNS ALL CHANNELS EXCEPT "MY TEAM" ONES
            return this.availableChannelsNoDupes.filter(item => item.channelType != 9999)
        },
        myTeamGroups() {
            return this.availableChannelsNoDupes.filter(item => item.channelType == 9999)
        },
    },
    methods: {
        selectChannel(salesChannel) {
            if (salesChannel == 'myTeam') {
                this.$emit('input', this.myTeamGroups)
            } else {
                this.$emit('input', [salesChannel])
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';
@import '~@/assets/scss/_utility.scss';

.channelBtn {
    @extend .border-medium;
    height: 40px;
    border-radius: 0.4rem !important;

    &:hover {
        @extend .bg-lighter;
    }

    &.selected {
        border-color: $color-3 !important;
        background-color: $color-3 !important;
        color: $lightest !important;
    }
}
</style>



// WEBPACK FOOTER //
// ChannelSelector.vue?dc0aa70a